import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaCogs, FaUserShield, FaBoxes, FaShieldAlt, FaHandshake, FaTrash, FaBus, FaQuestionCircle, FaChevronUp, FaChevronDown, FaTruck, } from 'react-icons/fa';
import { BsBank, BsCarFront, BsCarFrontFill, BsPersonBadge, BsShop } from 'react-icons/bs';
import Sidebar from '../../composant_reutilisable/sidebar';
import Navbar from '../../composant_reutilisable/navbar';
import useAuth from '../../composant_reutilisable/useAuth';
import { useNavigate } from 'react-router-dom';
import { FaHardDrive, FaTruckDroplet } from 'react-icons/fa6';
import GlossaireSidebar from '../../composant_reutilisable/glossaireSidebar';
import Pas_acces from '../../composant_reutilisable/pas_acces';
import axios from 'axios';

const Corbeilles = () => {
    useAuth();
    const user_id = localStorage.getItem('userId');
    const navigate = useNavigate();

    const [showInfo, setShowInfo] = useState(false);

    useEffect(() => {
        if (user_id) {

        }
    }, [user_id]);

    const menuItems = [
        //{ icon: <BsCarFrontFill />, text: 'Genre de Véhicules', link: '/Liste-genres-vehicules' },
        { icon: <FaTruck />, text: 'Corbeille des enrôlements', link: '/Enrolement-archives' },
        { icon: <FaBoxes />, text: 'Corbeille des frets', link: '/Liste-fret-corbeille' },

    ];

    const handleClick = (lien) => {
        navigate(lien);
    };

    const [showGlossary, setShowGlossary] = useState(false);

    const [accesGroupes, setAccesGroupes] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe_id');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe_id');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupes(JSON.parse(accesGroupeStored));
        } else {
            const token = localStorage.getItem('access_token');
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`,
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        },
                    });
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupes(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupes.includes("Corbeille")) {
        return (
            <Pas_acces />
        );
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className="d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center">
                                    <FaTrash size={25} className='mr-2' /> Corbeilles
                                    {/* <span
                                        className="ml-3 toggle-icon"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => setShowInfo(!showInfo)}
                                    >
                                        {showInfo ? <FaChevronUp /> : <FaChevronDown />}
                                    </span> */}
                                </div>

                                {/* Bouton d'aide complètement à droite */}
                                {/* <button
                                    className="btn btn-link p-0 ml-2"
                                    title="Manuel d'utilisation"
                                    onClick={() => navigate('/Manuel-utilisation-admin', {
                                        state: {
                                            fromModule: 'administration',
                                            fromSection: 'admin-corbeille'
                                        }
                                    })}
                                >
                                    <FaQuestionCircle size={18} />
                                </button> */}
                                <button
                                    className="btn btn-link p-0 ml-2"
                                    title="Aide"
                                    onClick={() => setShowGlossary(true)}
                                >
                                    <FaQuestionCircle size={18} />
                                </button>
                            </h2>
                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Menu`}> Accueil</Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <Link to={`/admin`}>Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        {/* <Link to={`/elementaires`}>Elementaires</Link> */}
                                        Corbeilles
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    <div className="wrapper wrapper-content animated fadeInRight text-center p-5">
                        <div className="row mx-auto justify-content-center">
                            {menuItems.map((item, index) => (
                                <div key={index} className="col-md-2 mb-4">
                                    <div className="card rounded shadow-sm" onClick={() => handleClick(item.link)} style={{ cursor: 'pointer' }}>
                                        <div className="card-body">
                                            <div className="mb-3 icon-small">{item.icon}</div>
                                            <h5><Link className='text-dark' to={item.link}>{item.text}</Link></h5>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                </div>
            </div>
            <GlossaireSidebar isOpen={showGlossary} onClose={() => setShowGlossary(false)} />
        </div>
    );
};

export default Corbeilles;
